
import store from '../store'
import './request'
import Echo from 'laravel-echo'
import Vue from "vue";
import httpIp from '../utils/httpConfig'
window.io = require('socket.io-client')
const info = JSON.parse(localStorage.getItem('user-info'))
if (info) {
  window.Echo = new Echo({
    auth:{ headers:{ Authorization:localStorage.getItem('Authorization') }},
    broadcaster: 'socket.io',
    host:httpIp.socket
  })
  window.Echo.private(`user.${info.id}`).listen('.bind.account',function (e) {
    Vue.prototype.$Bus.$emit('bindAccount')
  })
  window.Echo.private(`user.${info.id}`)
    .notification((notification) => {

      if (notification.type === 'download') {
        Vue.prototype.$Bus.$emit('download')
      } else if(notification.type === 'recharge' || notification.type === 'withdraw' || notification.type === 'vip'){
        Vue.prototype.$utils.info()
      } else if (notification.type === 'course_attache') {
        Vue.prototype.$Bus.$emit('attachDownload')
      } else if (notification.type === 'opus_download'){
        Vue.prototype.$Bus.$emit('download_works')
      }
      else if (notification.type === 'video_reward') {
         Vue.prototype.$Bus.$emit('video_reward')
      } else if (notification.type === 'question_answer') {
        Vue.prototype.$Bus.$emit('question_answer')
        Vue.prototype.$Bus.$emit('play_audio')
      } else if (notification.type === 'expert_question_deposit') {
        Vue.prototype.$Bus.$emit('expert_question_deposit')
      }
      Vue.prototype.$requestApi.api.userInfo().then ( res=> {
        store.state.status.message_count= res.data.notification_count
        localStorage.setItem('user-info',JSON.stringify(res.data))
      })
    })
}



// WEBPACK FOOTER //
// ./src/utils/socket.js